import type { ColumnsType } from "antd/es/table";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import { floatNumberInThousands } from "../../../utils/tools"

const lang = langPage?.card.record;

const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}

export const DEFAULT_QUERY_DATA = {
    Email: null,
    CardId: null,
    MemberId: null,
    Type: null,
    UdpayOrderStatus: null,
    CardholderEmail: null,
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '用户邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '持卡人邮箱',
            type: "input",
            field: "CardholderEmail",
            allowClear: true,
        },
        {
            title: lang?.cardId,
            type: "input",
            field: "CardId",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        {
            title: lang?.type,
            type: "select",
            field: "Type",
            allowClear: true,
            style: { width: 200 },
            options: [
                { id: 10, name: lang?.type1 },
                { id: 20, name: lang?.type2 }
            ],
        },
        {
            title: langPage?.card?.udpayProductStatus,
            type: "select",
            field: "UdpayOrderStatus",
            allowClear: true,
            style: { width: 200 },
            options: [
                { id: 'PENDING', name: 'PENDING' },
                { id: 'PROCESSING', name: 'PROCESSING' },
                { id: 'SUCCESS', name: 'SUCCESS' },
                { id: 'FAILED', name: 'FAILED' },
            ],
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    return [
        {
            title: '序号',
            dataIndex: "Index",
            render: (value, record, index) => {
                return index + 1
            }
        },
        {
            title: lang?.orderNo,
            dataIndex: "OrderNo",
        },
        {
            title: langPage?.card.main.member,
            dataIndex: "Member",
            render(value, record, index) {
                return value?.Email || ''
            },
        },
        {
            title: lang?.amount,
            dataIndex: "Amount",
            render: renderPrice
        },
        {
            title: lang?.commissionFee,
            dataIndex: "CommissionFee",
            render: renderPrice
        },
        {
            title: lang?.receivedAmount,
            dataIndex: "ReceivedAmount",
            render: renderPrice
        },
        {
            title: lang?.type,
            dataIndex: "TypeString",
        },
        {
            title: lang?.udpayOrderStatus,
            dataIndex: "UdpayOrderStatus",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
    ]
}


